import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { NoItemsWrapper } from '../General/NoItemsWrapper';
import { ProductTabDefault } from './ProductTabDefault';
import { LoaderWrapper } from '../General/LoaderWrapper';

interface Props {
  products: any;
  isFetching: boolean;
  visible?: boolean;
  isElasticCategory: boolean;
  productsInRow?: number;
  toggleFavourite: any;
  favouriteProducts?: any;
  isFavourite?: boolean;
  isAccountFavourite?: boolean;
}

export function ProductList({
  products,
  isFetching,
  visible = true,
  isElasticCategory,
  productsInRow = 4,
  toggleFavourite,
  favouriteProducts,
  isFavourite = false,
  isAccountFavourite = false,
}: Props) {
  const productsComponent =
    products &&
    products.map((p: any) => (
      <ProductTabDefault
        isElasticCategory={isElasticCategory}
        key={p.product_id}
        product={p}
        toggleFavourite={toggleFavourite}
        favouriteProducts={favouriteProducts}
        isFavourite={isFavourite}
        isAccountFavourite={isFavourite}
      />
    ));

  return (
    <ProductsCardWrapper
      visible={visible}
      productsInRow={productsInRow}
      isFavourite={isFavourite}
      isFetching={isFetching}
    >
      {isFetching ? (
        <LoaderWrapper height={500} />
      ) : productsComponent && productsComponent.length > 0 ? (
        productsComponent
      ) : (
        <NoItemsWrapper height={500} text={__('Nenašli sa žiadne produkty')} />
      )}
    </ProductsCardWrapper>
  );
}

const animateIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const ProductsCardWrapper = styled.div<{
  visible: boolean;
  productsInRow: number;
  isFavourite: boolean;
  isFetching: boolean;
}>`
  width: 100%;
  display: grid;
  grid-template-columns: ${props =>
    props.productsInRow
      ? `repeat(${props.productsInRow}, 1fr)`
      : `repeat(3, 1fr)`};
  gap: ${rem(32)};
  grid-row-gap: ${rem(32)};
  grid-auto-rows: minmax(${rem(136)}, auto);
  display: ${({ visible, isFetching }) =>
    visible ? (isFetching ? 'block' : 'grid') : 'none'};
  animation: ${animateIn} 0.2s ease;

  ${({ theme }) => theme.mediab.l1300`
    gap: ${rem(24)};
    grid-row-gap: ${rem(32)};
    grid-template-columns: repeat(3, 1fr);
  `};

  ${({ theme }) => theme.mediab.l1150`
    gap: ${rem(24)};
    grid-row-gap: ${rem(32)};
    grid-template-columns: repeat(2, 1fr);
  `};

  ${({ theme, isFavourite }) => theme.mediab.l925`
    gap: ${rem(24)};
    grid-row-gap: ${rem(32)};
    grid-template-columns: ${isFavourite ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)'};
  `};

  ${({ theme, isFavourite }) => theme.mediab.m810`
    gap: ${rem(16)};
    grid-row-gap: ${rem(32)};
    grid-template-columns: ${isFavourite ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)'};
  `};

  ${({ theme }) => theme.mediab.m580`
    grid-template-columns: repeat(2, 1fr);
  `}
`;
